import { modules } from "@core/utils/modules.js";
import TravelOrdersRouter from "@/views/operations/views/travel-orders/router/travel-orders.router.js";
import ServiceOrdersRouter from "@/views/operations/views/service-orders/router/service-orders.router.js";
import DocumentOrdersRouter from "@/views/operations/views/document-orders/router/document-orders.router.js";
import DocumentarySettlements from "@/views/operations/views/documentary-settlements/router/documentary-settlements.router.js";
import WorkshopAttendanceRoute from "@/views/operations/operations-attendance/router/operations-attendance.route.js"

import OperationMain from "@/views/operations/views/OperationsMain.vue";

const routes = [
    {
        path: "/operations",
        name: "operations",
        redirect: { name: "operations-travel-orders" },
        meta: { module: modules.OPERATIONS },
        component: OperationMain,
        children: [
            ...TravelOrdersRouter,
            ...ServiceOrdersRouter,
            ...DocumentOrdersRouter,
            ...DocumentarySettlements,
            ...WorkshopAttendanceRoute
        ]
    }
];

export default routes;